export default __webpack_public_path__ + "static/media/car.63ce1a14.jpg";